import { Address } from 'src/app/member/model/member';

export class HelperUtils
{
    public static daysConst(): string[]
    {
        return ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    }

    /**
     * Formatting the address in preparation for the Google map query.
     *
     * @param address Address to format
     */
    public static formatAddress(address: Address): string
    {
        let formattedAddress = '';
        if (address.streetLine)
        {
            formattedAddress += address.streetLine;
        }
        if (address.streetLineAdditional)
        {
            formattedAddress += (formattedAddress !== '' ? `, ` : '') + address.streetLineAdditional;
        }
        if (address.city)
        {
            formattedAddress += (formattedAddress !== '' ? `, ` : '') + address.city;
        }
        if (address.state)
        {
            formattedAddress += (formattedAddress !== '' ? `, ` : '') + address.state.code;
        }
        if (address.postalCode)
        {
            formattedAddress += (formattedAddress !== '' ? ` ` : '') + address.postalCode;
        }
        return formattedAddress;
    }

    public static formatFullAddress(address: Address): string
    {
        let formattedAddress = '';
        formattedAddress += address.streetLine == null || address.streetLine === '' ? '' : address.streetLine;
        formattedAddress += address.streetLineAdditional == null || address.streetLineAdditional === '' ?
            '' : ' ' + address.streetLineAdditional;
        formattedAddress += address.city == null || address.city === '' ? '' : (formattedAddress === '' ?
            address.city : ', ' + address.city);
        formattedAddress += address.county == null || address.county === '' ? '' : (formattedAddress === '' ?
            address.county : ', ' + address.county);
        formattedAddress += address.state == null ? '' : (formattedAddress === '' ?
            address.state.code : ', ' + address.state.code);
        formattedAddress += address.postalCode == null || address.postalCode === '' ? '' : (formattedAddress === '' ?
            address.postalCode : ', ' + address.postalCode);
        formattedAddress += address.country == null ? '' : (formattedAddress === '' ?
            address.country.code : ', ' + address.country.code);
        return formattedAddress;
    }

    /** City, county, state code, and postal line (no street lines) — matches patient header display rules. */
    public static formatAddressLocalityLine(address: Address): string
    {
        if (!address)
        {
            return '';
        }
        let s = '';
        if (address.city)
        {
            s += address.city;
        }
        if (address.county)
        {
            s += (address.city ? ', ' : '') + address.county;
        }
        if (address.state)
        {
            const code = address.state.code;
            s += (address.city || address.county ? ', ' : '') + (code ?? '');
        }
        if (address.postalCode)
        {
            s += (address.city || address.county || address.state ? ', ' : '') + address.postalCode;
        }
        return s;
    }

    public static isPrimaryAddress(address: Address, streetLine: string, streetLineAdditional: string,
        city: string, county: string, postalCode: string, stateCode: string, countryCode: string, addressTypeCode: string): boolean
    {
        return ((address.streetLine != null ? address.streetLine : '') === (streetLine != null ? streetLine : '')) &&
            ((address.streetLineAdditional != null ? address.streetLineAdditional : '') ===
                (streetLineAdditional != null ? streetLineAdditional : '')) &&
            ((address.city != null ? address.city : '') === (city != null ? city : '')) &&
            ((address.county != null ? address.county : '') === (county != null ? county : '')) &&
            ((address.postalCode != null ? address.postalCode : '') === (postalCode != null ? postalCode : '')) &&
            ((address.state != null && address.state.code != null ? address.state.code : '') === (stateCode != null ? stateCode : '')) &&
            ((address.country != null && address.country.code != null ? address.country.code : '')
                === (countryCode != null ? countryCode : '')) &&
            ((address.addressType.code != null ? address.addressType.code : '') === (addressTypeCode != null ? addressTypeCode : ''));
    }
}
